module.exports = __webpack_public_path__ + "media/locations/popular-city-1-832fd14f.png";